<script>
import metaInfo from '@/modules/mixins/metaInfo'
import AddressBlock from '@/components/organism/location/AddressBlock'
//import { mapGetters } from 'vuex'

export default {
    name: 'Addresses',
    components: { AddressBlock },
    mixins: [metaInfo],
    computed: {
        pageTitle() {
            return this.$t('profile.pages.addresses')
        },
    },
    mounted() {
        if (!this.$addresses.loaded) this.$addresses.fetch()
    },
    methods: {
        addAddress() {
            this.$location.add.open()
        },
        sortAddress() {
            this.$location.select.open()
            this.$location.select.showSorting()
        },
    },
}
</script>

<template lang="pug">
.profile-addresses
    .d-flex.justify-content-between.align-items-center.mb-3
        h2.my-0 {{ $t('profile.saved_addresses') }}
        div
          button.btn.btn-primary.btn-xs.mr-4(@click="sortAddress")
              icon.mr-2(icon="fa-solid fa-arrow-down-short-wide")
              | {{$t('details.address_sort')}}
          button.btn.btn-primary.btn-xs(@click="addAddress")
              icon.mr-2(icon="fa-solid fa-plus")
              | {{$t('base.add')}}
    .row
        .col-12.col-md-6.mb-8(v-for="(address, index) in $addresses.items" :key="`addressBlock-${index}`")
            address-block.h-100(:model="address.model")
</template>
